export default {"src":"/_next/static/media/chains-slateus.8e5338c7.svg","height":100,"width":100};